// extracted by mini-css-extract-plugin
export default {"header":"ModalMove_header__2aTiz","buttonFooterContainer":"ModalMove_buttonFooterContainer__7VNKL"};